import { useCallback } from "react";

import { Grid } from "@mui/material";
import { useTheme } from "@mui/styles";

export const DotSelector = ({
  isSelected,
  setSelectedIndex,
  index,
  size,
}: {
  isSelected: boolean;
  setSelectedIndex: (index: number) => void;
  index: number;
  size: "small" | "medium" | "large";
}) => {
  const width = size === "large" ? 32 : size === "medium" ? 18 : 8;
  const theme = useTheme();
  const handleClick = useCallback(() => {
    if (isSelected) {
      return;
    }
    setSelectedIndex(index);
  }, [index, isSelected, setSelectedIndex]);

  return (
    <Grid
      onClick={handleClick}
      sx={{
        width,
        height: width,
        backgroundColor: isSelected ? theme.palette.text.form.quiet : theme.palette.surface.form.moderate,
        cursor: isSelected ? "default" : "pointer",
        borderRadius: "50%",
      }}
    />
  );
};
